import React, { useState } from 'react';
import {
  QuizTitle,
  QuizSubtitle,
  CTAButton,
  LoadingSpinner,
} from '../styles/MFLancamentosStyles';
import {
  FormGroup,
  FormInput,
  FormLabel,
  FormError,
} from '../styles/LeadFormStyles';
import { supabase } from '../../../services/supabaseClient';

const LeadForm = ({ onSubmit }) => {
  const [form, setForm] = useState({ nome: '', telefone: '', email: '' });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const formatPhone = (value) => {
    const digits = value.replace(/\D/g, '').slice(0, 11);
    if (digits.length <= 2) return digits;
    if (digits.length <= 7) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
  };

  const handleChange = (field, value) => {
    if (field === 'telefone') value = formatPhone(value);
    setForm(prev => ({ ...prev, [field]: value }));
    if (errors[field]) setErrors(prev => ({ ...prev, [field]: '' }));
  };

  const validate = () => {
    const errs = {};
    if (!form.nome.trim()) errs.nome = 'Informe seu nome';
    const phoneDigits = form.telefone.replace(/\D/g, '');
    if (phoneDigits.length < 10) errs.telefone = 'Telefone invalido';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) errs.email = 'E-mail invalido';
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);

    const telefoneDigits = form.telefone.replace(/\D/g, '');
    const { data: lead, error } = await supabase
      .from('mf_leads_site')
      .insert({ nome: form.nome.trim(), telefone: telefoneDigits, email: form.email.trim(), origem: 'lancamentos' })
      .select('id')
      .single();

    if (!error && lead) {
      fetch('/api/mf-lead', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ lead_id: lead.id, evento: 'cadastro_lancamentos' }),
      }).catch(() => {});
    }

    setLoading(false);
    onSubmit({ ...form, lead_id: lead?.id });
  };

  return (
    <form onSubmit={handleSubmit} style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <QuizTitle>Receba as melhores oportunidades</QuizTitle>
      <QuizSubtitle style={{ maxWidth: '420px' }}>
        Cadastre-se e nossos especialistas vao selecionar as opcoes ideais para voce
      </QuizSubtitle>

      <FormGroup>
        <FormLabel htmlFor="nome">Nome</FormLabel>
        <FormInput
          id="nome"
          type="text"
          placeholder="Seu nome completo"
          value={form.nome}
          onChange={e => handleChange('nome', e.target.value)}
          $hasError={!!errors.nome}
          autoComplete="name"
        />
        {errors.nome && <FormError>{errors.nome}</FormError>}
      </FormGroup>

      <FormGroup>
        <FormLabel htmlFor="telefone">Telefone</FormLabel>
        <FormInput
          id="telefone"
          type="tel"
          placeholder="(11) 99999-9999"
          value={form.telefone}
          onChange={e => handleChange('telefone', e.target.value)}
          $hasError={!!errors.telefone}
          autoComplete="tel"
        />
        {errors.telefone && <FormError>{errors.telefone}</FormError>}
      </FormGroup>

      <FormGroup>
        <FormLabel htmlFor="email">E-mail</FormLabel>
        <FormInput
          id="email"
          type="email"
          placeholder="seu@email.com"
          value={form.email}
          onChange={e => handleChange('email', e.target.value)}
          $hasError={!!errors.email}
          autoComplete="email"
        />
        {errors.email && <FormError>{errors.email}</FormError>}
      </FormGroup>

      <CTAButton type="submit" disabled={loading} style={{ marginTop: '24px' }}>
        {loading ? (
          <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            Enviando <LoadingSpinner />
          </span>
        ) : (
          'Quero receber'
        )}
      </CTAButton>
    </form>
  );
};

export default LeadForm;
